export default __webpack_public_path__ + "static/media/folder-gray-no-data.933e5d4b.svg";